/// Layered desert rock silhouettes, drawn along the bottom of a dark sky panel.
/// The caller positions it and sets its height; it crops from the center to fit.
export function Landscape({ className }: { className?: string }) {
    return (
        <svg className={className} viewBox="0 0 1440 170" preserveAspectRatio="xMidYMax slice" aria-hidden="true" focusable="false">
            {/* Far ridge spans the full width so the nearer mesa in front never shows a seam */}
            <path d="M0 170 V108 L440 104 L560 100 L578 46 L612 30 L646 36 L664 78 L760 84 L778 56 L830 50 L850 88 L1000 96 L1020 66 L1080 60 L1100 90 L1220 96 L1240 40 L1270 30 L1300 36 L1320 82 L1440 88 V170 Z" fill="#9C4A26" />
            <path d="M0 170 V96 L60 90 L78 50 L118 44 L136 84 L260 90 L276 64 L330 58 L352 92 L520 100 L540 170 Z" fill="#7A3A22" />
            <path d="M0 170 V128 C220 114 420 132 640 122 C860 112 1100 130 1440 116 V170 Z" fill="#C7622C" />
            <path d="M0 170 V150 C300 140 560 156 860 146 C1100 139 1280 150 1440 144 V170 Z" fill="#E08A4A" />
            <path d="M0 170 V164 C400 158 900 168 1440 160 V170 Z" fill="#F4F2EA" />
        </svg>
    );
}
